// extracted by mini-css-extract-plugin
export default {"cardsList":"TableCardsList_cardsList__xWtFm","cardsListTitle":"TableCardsList_cardsListTitle__PIGP1"};